import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

// import '@ant-design/compatible/assets/index.css';


import { Tabs, Col, Input, Row, Spin } from 'antd';

import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import { FormInstance } from 'antd/lib/form';
import { getThirdPartyById } from 'services/thirdParty';

const { TabPane } = Tabs;

export type TabTPAddressProps = {
  objectid?: number;
  form?: FormInstance;
  setSuccessful: any;
};

const TabTPAddress = ({ objectid, form, setSuccessful }: TabTPAddressProps) => {
  // eslint-disable-next-line no-unused-vars
  const [state, setState] = useState<any>({
    address: {},
    generalData: {},
  });

  const { data, refetch, isFetching } = useQuery(
    ['getThirdPartyById', { tpid: objectid }],
    () => getThirdPartyById({ tpid: objectid! }).then((res) => res.data),
    { enabled: false }
  );

  useEffect(() => {
    setSuccessful(isFetching);
  }, [isFetching]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (data) {
      const { address } = data;

      form?.setFieldsValue({
        tpmainadrstreet1: address?.tpmainadrstreet1,
        tpmainadrstreet2: address?.tpmainadrstreet2,
        tpmainadrcity: address?.tpmainadrcity,
        tpmainadrzipcode: address?.tpmainadrzipcode,
        tpmainadrregion: address?.tpmainadrregion,
        tpmainadrcountry: address?.tpmainadrcountry,
      });

      setState((prev: any) => ({
        ...prev,
        address: data,
      }));
    }
  }, [data, form]);

  return (
    <DF.Provider pagcode="TabTPAddress">
      <Spin spinning={isFetching}>
        <Row>
          <Col span={24}>
            <Tabs animated defaultActiveKey="1" type="line">
              <TabPane tab="Main Address" key="1" forceRender>
                <Row gutter={[0, 0]}>
                  <Col xs={24}>
                    <FormInput
                      name="tpmainadrstreet1"
                      rules={[{ required: true }]}
                    >
                      <Input></Input>
                    </FormInput>
                  </Col>
                  <Col xs={24}>
                    <FormInput
                      name="tpmainadrstreet2"
                      rules={[{ required: true }]}
                    >
                      <Input></Input>
                    </FormInput>
                  </Col>
                  <Col xs={16}>
                    <FormInput
                      name="tpmainadrcity"
                      rules={[{ required: true }]}
                    >
                      <Input></Input>
                    </FormInput>
                  </Col>
                  <Col xs={8}>
                    <FormInput
                      name="tpmainadrzipcode"
                      rules={[{ required: true }]}
                    >
                      <Input></Input>
                    </FormInput>
                  </Col>
                  <Col xs={16}>
                    <FormInput
                      name="tpmainadrregion"
                      rules={[{ required: true }]}
                    >
                      <Input></Input>
                    </FormInput>
                  </Col>
                  <Col xs={8}>
                    <FormInput
                      name="tpmainadrcountry"
                      rules={[{ required: true }]}
                    >
                      <Input></Input>
                    </FormInput>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tab="Second Address" key="2" forceRender>
                <Row gutter={[0, 0]}>
                  <Col xs={24}>
                    <FormInput
                      name="tpsecadrstreet1"
                      rules={[{ required: false }]}
                    >
                      <Input></Input>
                    </FormInput>
                  </Col>
                  <Col xs={24}>
                    <FormInput
                      name="tpsecadrstreet2"
                      rules={[{ required: false }]}
                    >
                      <Input></Input>
                    </FormInput>
                  </Col>
                  <Col xs={16}>
                    <FormInput
                      name="tpsecadrcity"
                      rules={[{ required: false }]}
                    >
                      <Input></Input>
                    </FormInput>
                  </Col>
                  <Col xs={8}>
                    <FormInput
                      name="tpsecadrzipcode"
                      rules={[{ required: false }]}
                    >
                      <Input></Input>
                    </FormInput>
                  </Col>
                  <Col xs={16}>
                    <FormInput
                      name="tpsecadrregion"
                      rules={[{ required: false }]}
                    >
                      <Input></Input>
                    </FormInput>
                  </Col>
                  <Col xs={8}>
                    <FormInput
                      name="tpsecadrcountry"
                      rules={[{ required: false }]}
                    >
                      <Input></Input>
                    </FormInput>
                  </Col>
                </Row>
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </Spin>
    </DF.Provider>
  );
};
export default TabTPAddress;
